import kalkulatorResultTemplate from './kalkulator-result.pug';
import { tooltipHack } from '../../../common/tooltip/tooltip';
import TipusBase from '../lib/tipus-base'
export const KalkulatorResultComponent = {
	template: kalkulatorResultTemplate(),
	transclude: {
		tooltipResultContent: 'tooltipResultContent'
	},
	bindings: {
		eredmeny: '<',
		tipus: '<'
	},
	controller: class KalkulatorResultController extends TipusBase {
		constructor($element) {
			'ngInject';
			super();
			this.$element = $element[0];
		}
		$onInit() {
			setTimeout(() => {
				let tooltips = Array.from(this.$element.querySelectorAll('.tooltip'));
				tooltips.forEach(item => {
					setTimeout(() => {
						new tooltipHack();
					}, 0);
				});
			}, 0);
		}
		getPdfUrl() {
			let apiType = this.isMegtakaritas() ? 'megtakaritas' : 'jaradek';
			let url = '';
			if (this.eredmeny) {
				url = `/api/kalkulator/${apiType}/pdf/${this.eredmeny.id}`
			}
			return url;
		}
	}
}



// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator-result/kalkulator-result.component.js